<div *ngIf="godModeUser" class="god-mode-banner">
  <div class="god-mode-banner-content">
    <span class="god-mode-pulse"></span>
    <span class="god-mode-text">
      ⚡ <strong>GOD MODE</strong> &nbsp;·&nbsp; Viewing as <strong>{{godModeUser.firstName}} {{godModeUser.lastName}}</strong>
      <span class="god-mode-email">{{godModeUser.email}}</span>
    </span>
  </div>
  <button type="button" class="god-mode-exit-btn" (click)="exitGodMode()">
    ✕ Exit
  </button>
</div>

<app-verification-banner></app-verification-banner>

<div class="web main" [class.god-mode-active]="godModeUser" [class.practice-view]="isPracticeView">
  <app-sidebar-menu></app-sidebar-menu>
  <!-- SD-1235: below 992px the menu is a drawer over the page; tapping beside it closes it. -->
  <div class="snav-scrim" *ngIf="sharedService?.isShowSideNav" (click)="sharedService.isShowSideNav = false"
       aria-hidden="true"></div>
  <div [ngClass]="{ 'open': sharedService?.isShowSideNav }" class="data">
    <app-header></app-header>
    <section>
      <router-outlet></router-outlet>
    </section>
  </div>
</div>

<app-verification-required-modal></app-verification-required-modal>